import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarDays, Clock, Video, RotateCcw, CalendarPlus } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmtDate = (d) => new Date(d + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
const fmtTime = (t) => { if (!t) return ''; const [h, m] = t.split(':').map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`; };

export default function UpcomingBookings() {
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API_URL}/api/portal/bookings`, { withCredentials: true }).then((r) => setRows(r.data || [])).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section className="mb-10" data-testid="portal-upcoming-bookings">
      <h2 className="font-semibold mb-4 text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>Booked calls</h2>
      <div className="grid md:grid-cols-2 gap-4">
        {rows.map((b) => (
          <div key={b.booking_id} className="p-card rounded-2xl p-5" data-testid={`portal-booking-${b.booking_id}`}>
            <div className="font-semibold">{b.session_type || 'Strategy session with David'}</div>
            <div className="flex flex-wrap gap-3 text-sm mt-1.5" style={{ color: 'var(--p-muted)' }}>
              <span className="flex items-center gap-1.5"><CalendarDays size={14} className="text-[#1D4ED8]" />{fmtDate(b.date)}</span>
              <span className="flex items-center gap-1.5"><Clock size={14} className="text-[#1D4ED8]" />{fmtTime(b.time)}</span>
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
              {b.zoom_join_url && <a href={b.zoom_join_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-[#1D4ED8] hover:bg-[#2563EB] text-white px-3.5 py-2 rounded-lg text-xs font-semibold"><Video size={13} /> Join Zoom</a>}
              <a href={`${API_URL}/api/bookings/${b.booking_id}/calendar.ics`} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold border" style={{ borderColor: 'var(--p-border)' }}><CalendarPlus size={13} /> Add to calendar</a>
              {b.manage_token && <a href={`/embed/manage?token=${b.manage_token}&brand=dca`} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold border" style={{ borderColor: 'var(--p-border)' }}><RotateCcw size={13} /> Reschedule</a>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
